<template>
  <div class="my-promotion">
    <nav-bar
        fixed
        z-index="99"
        title=""
        left-text="返回"
        left-arrow
        @click-left="$router.go(-1)"
    />
    <div style="height: 46px"></div>
    <div class="header">
      <div class="status-bar">
        <div class="signing-info">
          <div v-if="$store.state.app.isSign == 0" class="sign-notice">
            个人银行卡提现前需与灵活用工平台签约
            <div @click="showAgreementPreview" class="sign-status not-signed">
              <i class="sign-icon">!</i> 去签约
            </div>
          </div>


        </div>
        <div class="left-buttons"  v-if="$store.state.app.isSign != 0">
          <template>
            <div class="sign-status signed" @click="goToUnbind">
              <i class="sign-icon">✓</i> 已签约灵工平台
            </div>
            <!-- 合同按钮单独一行 -->
            <div class="contract-row">
              <div @click="viewContract" class="contract-btn">
                <img src="@assets/img/eye.png">点击查看灵工合同<i class="iconfont icon-xiazai"></i>
              </div>
            </div>
          </template>
        </div>
        <div class="right-links">
          <router-link
              class="record"
              :to="'/user/cashrecord'"
          >
            提现记录<span class="iconfont icon-xiangyou"></span>
          </router-link>
        </div>
      </div>


    </div>
    <div class="list acea-row row-between-wrapper" style="flex-wrap: wrap">
      <div
          class="item acea-row row-center-wrapper row-column"
          @click="$router.push('/user/commission')"
      >
        <!-- <span class="iconfont icon-qiandai"></span> -->
        <img
            style="width: 35px; height: 35px; margin-bottom: 10px"
            src="@/assets/images/promotion1.png"
            alt=""
        />
        <div>佣金明细</div>
      </div>

      <div
          class="item acea-row row-center-wrapper row-column"
          @click="handleOrderClick"
      >
        <img
            style="width: 35px; height: 35px; margin-bottom: 5px"
            src="@/assets/images/promotion2.png"
            alt=""
        />
        <div>未提现订单</div>
        <div
            style="
            font-size: 0.23rem;
            color: #888;
            margin-top: 10px;
            white-space: nowrap;
          "
        >
          (未提现金额：<span
            style="color: aqua; font-weight: bold; white-space: nowrap"
        >￥{{ Info.commissionCount }}</span
        >)
        </div>
      </div>

      <div
          class="item acea-row row-center-wrapper row-column"
          @click="
          $router.push({ path: '/user/user_cash_list', query: { type: 12 } })
        "
      >
        <img
            style="width: 35px; height: 35px; margin-bottom: 5px"
            src="@/assets/images/promotion3.png"
            alt=""
        />
        <div>提现中订单</div>
        <div style="font-size: 0.23rem; color: #888; margin-top: 10px">
          (提现中金额：<span
            style="color: aqua; font-weight: bold; white-space: nowrap"
        >￥{{ Info.unExtractCount || 0 }}</span
        >)
        </div>
      </div>

      <div
          class="item acea-row row-center-wrapper row-column"
          @click="
          $router.push({ path: '/user/user_cash_list', query: { type: 13 } })
        "
      >
        <img
            style="width: 35px; height: 35px; margin-bottom: 5px"
            src="@/assets/images/promotion4.png"
            alt=""
        />
        <div>已提现订单</div>
        <div style="font-size: 0.23rem; color: #888; margin-top: 10px">
          (已提现金额：<span
            style="color: aqua; font-weight: bold; white-space: nowrap"
        >￥{{ Info.extractCount }}</span
        >)
        </div>
      </div>
    </div>

    <!-- 协议预览弹窗 -->
    <div class="agreement-popup" v-show="showAgreementPopup">
      <div class="agreement-container">
        <div class="agreement-header">
          <div class="agreement-title">签约协议</div>
          <div class="agreement-close" @click="closeAgreementPopup">×</div>
        </div>
        <div class="agreement-content">
          <img src="@/assets/img/PDF1.jpg" />
          <img src="@/assets/img/PDF2.jpg" />
          <img src="@/assets/img/PDF3.jpg" />
          <img src="@/assets/img/PDF4.jpg" />
          <img src="@/assets/img/PDF5.jpg" />
          <img src="@/assets/img/PDF6.jpg" />
        </div>
        <div class="agreement-footer">
          <div class="agreement-btn cancel" @click="closeAgreementPopup">返回</div>
          <div class="agreement-btn confirm" @click="confirmAgreement">同意并签约</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getSpreadInfo, getUserInfo, signFind, getPdfProxy } from "../../../api/user";
import { NavBar, Dialog, Toast } from "vant";

export default {
  name: "UserPromotion",
  components: {
    NavBar,
    VanDialog: Dialog.Component,
  },
  props: {},
  data() {
    return {
      Info: {
        lastDayCount: 0,
        extractCount: 0,
        commissionCount: 0,
        unExtractCount: 0,
        isSign: 0
      },
      showSignDialog: false,
      showAgreementPopup: false
    };
  },
  computed: {
    storeIsSign() {
      //后台输出保存的所有值
      console.log('获取保存在$store.state.app的信息', this.$store.state.app);
      return this.$store.state.app.isSign;
    }
  },
  created() {
    this.checkUserInfo();
    this.getInfo();
  },
  activated() {
    this.checkUserInfo();
    this.getInfo();
  },
  mounted() {
    this.checkUserInfo();
    this.getInfo();
  },
  methods: {
    getInfo() {
      getSpreadInfo().then(
          (res) => {
            this.Info = res.data;
            console.log('获取推广信息成功:', this.Info);
          },
          (err) => {
            console.error('获取推广信息失败:', err);
            Dialog.alert({
              title: '提示',
              message: err.msg || '获取数据失败'
            });
          }
      );
    },
    checkUserInfo() {
      getUserInfo().then(res => {
        console.log('获取用户信息成功:', res.data);
        this.$store.commit("SET_USER", res.data);
      }).catch(err => {
        console.error("获取用户信息失败:", err);
      });
    },
    toCash() {
      this.$router.push({ path: "/user/user_cash" });
    },
    handleOrderClick() {
      console.log('用户点击未提现订单');
      this.$router.push({ path: '/user/user_cash_list', query: { type: 11 } });
    },
    goToSign() {
      this.$router.push({
        path: "/user/signing",
      });
    },
    goToUnbind() {
      this.$router.push({
        path: "/user/user_unbind",
      });
    },
    viewContract() {
      // 显示加载中提示
      Toast.loading({
        message: '正在获取合同...',
        forbidClick: true,
        duration: 0
      });

      // 调用签约合同查询API
      signFind().then(res => {
        // 关闭加载提示
        Toast.clear();
        console.log('获取合同信息成功:', res);
        if (res.data) {// API返回成功且有数据
          // 获取到PDF URL
          const originalPdfUrl = res.data;

          // 直接使用原始URL，不通过代理
          console.log('PDF原始URL:', originalPdfUrl);

          // 跳转到PDF查看器组件
          this.$router.push({
            path: '/pdf/simple-viewer',
            query: {url: encodeURIComponent(originalPdfUrl)}
          });
        } else {
          // API返回成功但无数据
          Dialog.alert({
            title: '提示',
            message: res.msg || '未找到合同信息'
          });
        }
      }).catch(err => {
        // 关闭加载提示
        Toast.clear();

        // 记录错误并显示提示
        console.error('获取合同失败:', err);
        Dialog.alert({
          title: '提示',
          message: err.msg || '获取合同失败，请稍后再试'
        });
      });
    },
    showAgreementPreview() {
      this.showAgreementPopup = true;
    },
    closeAgreementPopup() {
      this.showAgreementPopup = false;
    },
    confirmAgreement() {
      // 实现确认协议的逻辑
      this.showAgreementPopup = false;
      this.goToSign();
    }
  },
};
</script>
<style scoped>
.header {
  background-color: #fff;
  height: auto; /* 使用自动高度 */
  min-height: 2rem; /* 最小高度 */
  padding-bottom: 15px; /* 底部增加一些空间 */
  width: 100%;
  position: relative;
  overflow: hidden;
}

.status-bar {
  width: 100%;
  padding: 0 15px;
  display: flex;
  justify-content: space-between;
  align-items: center; /* 中心对齐 */
  margin-top: 15px;
  margin-bottom: 10px;
}

.left-buttons {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  padding: 0 15px;
  margin-right:120px;
}

.signing-info {
  display: flex;
  align-items: center;
}

.sign-notice {
  font-size: 13px;
  color: #000000;
  display: inline-block;
}

.sign-status {
  display: flex;
  align-items: center;
  padding: 0 10px;
  height: 28px;
  border-radius: 14px;
  font-size: 12px;
  cursor: pointer;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
}

.contract-row {
  margin-top: 5px;
  display: flex;
  align-items: center;
}

.contract-btn {
  display: inline-flex;
  align-items: center;
  padding: 0 10px;
  height: 28px;
  border-radius: 14px;
  font-size: 11px;
  background-color: #f9f9f9;
  color: #666;
  border: 1px solid #ddd;
  cursor: pointer;
  transition: all 0.3s ease;
}

.contract-btn i {
  margin-left: 2px;
  font-size: 10px;
}

.sign-status:hover {
  transform: translateY(-1px);
  box-shadow: 0 3px 8px rgba(0, 0, 0, 0.15);
}

.sign-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 14px;
  height: 14px;
  border-radius: 50%;
  margin-right: 4px;
  font-style: normal;
  font-weight: bold;
  font-size: 10px;
}

.not-signed {
  background: linear-gradient(135deg, #ff6c6c, #ff4b4b);
  color: white;
  width: 80px;
}

.not-signed .sign-icon {
  background-color: rgba(255, 255, 255, 0.25);
  color: white;
}

.signed {
  background: linear-gradient(135deg, #52c41a, #3eb712);
  color: white;
}

.signed .sign-icon {
  background-color: rgba(255, 255, 255, 0.25);
  color: white;
}

.record {
  color: #666;
  font-size: 0.26rem;
  display: flex;
  align-items: center;
}

.right-links {
  display: flex;
  align-items: center; /* 中心对齐 */
  gap: 15px;
}

.apply-withdraw {
  color: #666;
  font-size: 0.26rem;
  display: flex;
  align-items: center;
}

.apply-withdraw:active,
.record:active {
  opacity: 0.7;
}

/* 自定义对话框样式 */
:global(.custom-dialog .van-dialog__confirm) {
  color: #0ce6df !important;
  font-weight: bold;
}

/* PDF查看器对话框样式 */
:global(.pdf-viewer-dialog) {
  width: 95% !important;
  max-width: 100%;
  height: auto;
  overflow: hidden;
  border-radius: 8px;
}

:global(.pdf-viewer-dialog .van-dialog__content) {
  padding: 0;
  margin: 0;
}

:global(.pdf-viewer-dialog .van-dialog__message) {
  padding: 0;
  margin: 0;
  max-height: 80vh;
  overflow: hidden;
}

:global(.pdf-viewer-dialog .van-button) {
  margin-top: 8px;
}

/* 协议弹窗样式 */
.agreement-popup {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 999;
}

.agreement-container {
  width: 100%;
  height: 100%;
  background-color: #fff;
  display: flex;
  flex-direction: column;
}

.agreement-header {
  height: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  border-bottom: 1px solid #f5f5f5;
}

.agreement-title {
  font-size: 18px;
  font-weight: bold;
  color: #333;
}

.agreement-close {
  position: absolute;
  right: 15px;
  top: 0;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  color: #999;
  width: 50px;
  cursor: pointer;
}

.agreement-content {
  flex: 1;
  overflow-y: auto;
  padding: 2px;
  background-color: #f5f5f5;
}

.agreement-content img {
  width: calc(100% - 4px);
  display: block;
  margin: 0 0 2px 0;
}

.agreement-footer {
  height: 60px;
  display: flex;
  border-top: 1px solid #f5f5f5;
}

.agreement-btn {
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 16px;
  font-weight: 500;
}

.cancel {
  color: #666;
  background-color: #f5f5f5;
}

.confirm {
  color: #fff;
  background-color: #0ce6df;
}
</style>
